import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  AllCollectionPointDetails,
  getCollectionPointsById,
  AllCollectionPointTypeDetails,
} from "../../Apis/collectionPointsApi";
import {
  GetZone,
  GetCirclebyID,
  GetWardsbyCircleId,
} from "../../Apis/organizationApi";
import { AllShiftMaster } from "../../Apis/shiftMasterApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import Loader from "../../Common/Loader/loader";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import imageCompression from "browser-image-compression";

import "leaflet/dist/leaflet.css";

import isGHMC from "../../Common/helper/helpar";
import AddCollectionPoint from "./AddCollectionPoint";
import e from "cors";

const GvpMaster = ({ t }) => {
  const headers = [
    "collectionPointName",
    "collectionPointType",
    "collectionPointCode",
    "zone",
    "circle",
    "ward",
    "latitude",
    "longitude",
    "shiftA",
    "shiftB",
    "shiftC",
    "status",
    "actions",
  ];
  const isProd = isGHMC();
  const navigate = useNavigate();
  const [lgShow, setLgShow] = useState(false);
  const [fetchDataLoaded, setFetchDataLoaded] = useState(false);
  const [collectionPointDetails, setCollectionPointDetails] = useState([]);
  const [collectionDetails, setCollectionDetails] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [isCollectionLoading, setIsCollectionLoading] = useState(true);
  const [circleFetchError, setCircleFetchError] = useState(null);
  const [editCollectionDetails, setEditCollectionDetails] = useState("");
  const [edit, setEdit] = useState(false);
  const [selectedZone, setSelectedZone] = useState("");
  const [shiftData, setShiftData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [collectionPointTypes, setCollectionPointTypes] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [selectedCircle, setSelectedCircle] = useState("");
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [circles, setCircles] = useState([]);
  const [loadingWards, setLoadingWards] = useState(false);
  const [collectionImageName, setCollectionmageName] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [isActive, setIsActive] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [zoneId, setzoneId] = useState();
  const center = {
    lat: 17.452555,
    lng: 78.3599819,
  };
  const [formInput, setFormInput] = useState({
    collectionTypeId: "",
    collectionPointId: "",
    zoneId: "",
    circleId: "",
    wardId: "",
    collectionPointName: "",
    latitude: center.lat,
    longitude: center.lng,
    shiftId: "",
    collectionPointCode: "",
    landmark: "",
    ShiftA: null,
    ShiftB: null,
    ShiftC: null,
    isActive: true,
    ImageUrl: "",
  });
  const libraries = ["places"];
  const [
    selectedCollectionPointCoordinates,
    setSelectedCollectionPointCoordinates,
  ] = useState(center);

  useEffect(() => {
    // Fetch collection point types when the component mounts
    fetchCollectionPointTypes();
    fetchAllCollectionData();
  }, []);

  const fetchCollectionPointTypes = async () => {
    try {
      const response = await AllCollectionPointTypeDetails(); // Call the API function to fetch collection point types
      setCollectionPointTypes(response); // Update the state with the fetched collection point types
    } catch (error) {
      console.error("Error fetching collection point types:", error);
    }
  };
  const handleClose = async () => {
    setEdit(false);

    setEditCollectionDetails(null);
    setLgShow(false);
    setFormSubmitted(false);
    setAllCircles([]);
    setAllWards([]);
  };

  const handleShow = () => {
    setLgShow(true);

    setEditCollectionDetails(null);
    setImagePreview(null);
  };

  const handleEditCollectionDetails = (selectedData) => {
    setEditCollectionDetails(selectedData);
    setEdit(true);
    // Removed API calls - AddCollectionPoint component will handle fetching circles and wards
    setLgShow(true);
  };

  const handleCircleChange = (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      wardId: "", // Reset ward when circle changes
    }));
    // Removed duplicate GetWardsbyCircleId call - useEffect handles it
  };

  useEffect(() => {
    if (formInput.circleId) {
      // Fetch wards for the selected circle
      fetchWardsData(formInput.zoneId, formInput.circleId);
      // Reset ward when circle changes
      setFormInput((prevData) => ({
        ...prevData,
        wardId: formInput.wardId,
      }));
    }
    // Removed duplicate fetchCirclesData call - handleZoneChange already handles it
  }, [formInput.circleId]);
  // ---------------------wards-----------
  const fetchWardsData = async (zoneId, circleId) => {
    try {
      // setIsLoading(true);
      const response = await GetWardsbyCircleId(circleId);
      setAllWards(response);
    } catch (error) {
      console.error("Error fetching wards data:", error);
    } finally {
      //  setIsLoading(false);
    }
  };

  const fetchAllCollectionData = async () => {
    try {
      setIsCollectionLoading(true);
      const collectionPointsData = await AllCollectionPointDetails();
      setCollectionPointDetails(collectionPointsData);
      setFetchDataLoaded(true);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsCollectionLoading(false);
    }
  };

  // Fetch zones data once on mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const zonesData = await GetZone();
        setAllZones(zonesData);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    const fetchShiftData = async () => {
      try {
        setIsLoading(true);
        const shiftDataResponse = await AllShiftMaster();
        setShiftData(shiftDataResponse);
      } catch (error) {
        console.error("Error fetching shift data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchShiftData();
  }, []);


  const handleViewCollectionPoints = async (id) => {
    try {
      const response = await getCollectionPointsById(id);
      const collectionPointDetails = response.data.data;
      navigate("/view-collection-points-details", {
        state: { collectionPointDetails },
      });
    } catch (error) {
      //  console.log(error);
    }
  };

  const fetchAllCollectionPointDetails = async () => {
    const {
      zoneId,
      circleId,
      wardId,
      shiftId,
      collectionPointCode,
      collectionTypeId
    } = formInput;

    try {
      setIsLoading(true);
      const isActiveFilter = isActive !== "" ? isActive : null;
      // Use stored data instead of calling APIs again
      const collectionPointDetails = await AllCollectionPointDetails({
        zoneId: zoneId || null,
        circleId: circleId || null,
        wardId: wardId || null,
        shift: shiftId || null,
        isActive: isActiveFilter,
        collectionPointCode: collectionPointCode,
        CollectionPointTypeId: collectionTypeId
      });
      
      // Use stored data for lookup (only zones, wards and circles not fetched)
      const zoneNameResponse = allZones.length > 0 ? allZones : [];

      const collectionPointData = collectionPointDetails.map((station) => {
        const zone = zoneNameResponse.find(
          (zone) => zone.zoneId === station.zoneId
        );
        return {
          ...station,
          ward: station.wardName || "N/A",
          zone: zone ? zone.zoneName : (station.zoneName || "N/A"),
          circle: station.circleName || "N/A",
          collectionPointType: station.collectionPointTypeName,
          collectionPoint: station.collectionPointName,
          status: station.isActive ? "Active" : "InActive",
        };
      });

      const sortedCollectionPointsData = collectionPointData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setCollectionDetails(sortedCollectionPointsData);
      setOriginalData(collectionPointData);
      setFilteredData(sortedCollectionPointsData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching collection point details:", error);
    }
  };

  useEffect(() => {
    fetchAllCollectionPointDetails();
  }, []);

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadAsExcel = async (dataToUse) => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Collection Point Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Collection Points");

    const boldFont = { bold: true };

    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 12); // Adjust to account for new columns
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 12; col++) { // Adjust to account for new columns
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow(["", "", "Collection Points", ""]);
    worksheet.mergeCells(2, 2, 2, 12); // Adjust to account for new columns
    worksheet.getCell(2, 2).value = "Collection Point Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 12; col++) { // Adjust to account for new columns
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow([""]);

    // Add header row with the new Shift columns (Shift A, Shift B, Shift C)
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Collection Point Name",
      "Collection Point Type",
      "Collection Point Code",
      "Zone",
      "Circle",
      "Ward",
      "Latitude",
      "Longitude",
      "Shift A",   // New column for Shift A
      "Shift B",   // New column for Shift B
      "Shift C",   // New column for Shift C
      "Status",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Align text to the left
      if (colNumber >= 1 && colNumber <= 12) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },  // Background color for header
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.collectionPointName,
        item.collectionPointTypeName,
        item.collectionPointCode,
        item.zone,
        item.circle,
        item.ward,
        item.latitude,
        item.longitude,
        item.shiftA ? true : false, // Shift A availability check
        item.shiftB ? true : false, // Shift B availability check
        item.shiftC ? true : false, // Shift C availability check
        item.status,
      ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.alignment = { horizontal: "left" }; // Align text to the left
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },   // S.No
      { width: 25 },  // Collection Point Name
      { width: 25 },  // Collection Point Code
      { width: 20 },  // Zone
      { width: 20 },  // Circle
      { width: 15 },  // Ward
      { width: 15 },  // Latitude
      { width: 15 },  // Longitude
      { width: 10 },  // Shift A
      { width: 10 },  // Shift B
      { width: 10 },  // Shift C
      { width: 20 },  // Status
      { width: 20 },  // Status
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CollectionPointDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const handleSort = async (config) => {
    const sortedArray = [...collectionDetails].sort((a, b) => {
      const aField = a[config.key];
      const bField = b[config.key];

      if (aField < bField) return config.direction === "ascending" ? -1 : 1;
      if (aField > bField) return config.direction === "ascending" ? 1 : -1;
      return 0;
    });

    setSortedData(sortedArray); // Update sorted data state
  };

  const handleSortAndExport = async () => {
    if (sortConfig) {
      await handleSort(sortConfig); // Apply sorting and ensure it completes
    }

    // Determine which data to export
    const dataToExport =
      sortedData && sortedData.length > 0
        ? sortedData
        : filteredData.length > 0
          ? filteredData
          : originalData;

    downloadAsExcel(dataToExport); // Export the appropriate data
  };
  const handleZoneChange = async (zoneId) => {
    setFormInput((prevData) => ({
      ...prevData,
      zoneId: zoneId,
      circleId: "",
    }));
    setSelectedCircle("");
    if (zoneId) {
      fetchCirclesData(zoneId);
    } else {
      setCircles([]);
      setAllWards([])
    }
  };
  // circles
  const fetchCirclesData = async (zoneId) => {
    try {
      const response = await GetCirclebyID(zoneId);
      setCircles(response);

      setCircleFetchError(null); // Clear error if successful
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setCircles([]); // Clear circles data on error

      setCircleFetchError(
        error.response ? error.response.data.message : "Unknown error occurred"
      );
      toast.error(`Error fetching circles: ${circleFetchError}`);
    }
  };

  const handleShiftChange = (shift) => {
    const shiftId = shiftMapping[shift] || null;
    setFormInput((prevData) => ({
      ...prevData,
      shiftId,
    }));
  };

  const handleCollectionTypeChange = (e) => {
    const collectionTypeId = e.target.value;
    setFormInput((prevData) => ({
      ...prevData,
      collectionTypeId,
    }));
  };


  const shiftMapping = {
    shiftA: 1,
    shiftB: 2,
    shiftC: 3,
  };

  const handleActiveChange = (status) => {
    const mappedStatus =
      status === "true" ? true : status === "false" ? false : "";
    setIsActive(mappedStatus);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header my-2">
              <div className="vehicle-button my-2">
                {canWriteValue === true ? (
                  <button className="button-container" onClick={handleShow}>
                    <i className="fa-solid fa-plus me-1 icon-container"></i>
                    {t("addCollection")}
                  </button>
                ) : (
                  ""
                )}
                <button className="btn btn-excel" onClick={handleSortAndExport}>
                  <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                  Excel
                </button>
              </div>
            </div>
            {/*----------------- Filters-------------- */}
            <div className="">
              <div className="page-header-left">
                <div className="row align-items-end">
                  <div className="col-md-11">
                    <div className="row g-2">
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1 small mb-1 small">Collection Code</label>
                          <input
                            type="text"
                            name="vehicleTypeCode"
                            className="bg-white"
                            style={FilterinputStyle}
                            placeholder="Collection Code"
                            value={formInput.collectionPointCode}
                            onChange={(e) => {
                              setFormInput((prevData) => ({
                                ...prevData,
                                collectionPointCode: e.target.value,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1 small mb-1 small">Collection Type</label>
                          <select
                            value={formInput.collectionTypeId || ""}
                            id="vehicle-filter-input"
                            name="collectionTypeId"
                            className={`form-select ${formInput.collectionTypeId || !formSubmitted
                                ? ""
                                : "input-error"
                              }`}
                            onChange={handleCollectionTypeChange}
                          >
                            <option value="">Select</option>
                            {collectionPointTypes.map((collectionPoint) => (
                              <option
                                value={collectionPoint.collectionPointTypeId}
                                key={collectionPoint.collectionPointTypeId}
                              >
                                {collectionPoint.collectionPointTypeName}
                              </option>

                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1 small mb-1 small">
                            {/* {t("vehicleZone")} */}
                            Zone
                          </label>
                          <select
                            value={formInput.zoneId}
                            id="vehicle-filter-input"
                            name="zoneId"
                            className={`form-select ${formInput.zoneId || !formSubmitted
                                ? ""
                                : "input-error"
                              }`}
                            onChange={(e) => handleZoneChange(e.target.value)}
                          //disabled={!formInput.zoneId}
                          >
                            <option value="">Select</option>
                            {allZones?.filter((zone) => zone.isActive)
                              .map((zone) => (
                                <option key={zone.zoneId} value={zone.zoneId}>
                                  {zone.zoneName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1 small mb-1 small">
                            {/* {t("vehicleCircle")}{" "} */}
                            Circle
                          </label>
                          <select
                            className={`form-select ${formInput.circleId || !formSubmitted
                                ? ""
                                : "input-error"
                              }`}
                            name="circleId"
                            id="vehicle-filter-input"
                            value={formInput.circleId}
                            // onChange={(e) => handleCircleChange(e.target.value)}
                            onChange={(e) => {
                              setFormInput((prevData) => ({
                                ...prevData,
                                circleId: e.target.value,
                              }));
                              handleCircleChange(e.target.value);
                            }}
                          //disabled={!formInput.circleId}
                          >
                            <option value="">Select</option>

                            {formInput.zoneId ? (
                              loadingCircles ? (
                                <option>Loading circles...</option>
                              ) : circles.length > 0 ? (
                                circles.filter((circle) => circle.isActive)
                                  .map((circle) => (
                                    <option
                                      key={circle.circleId}
                                      value={circle.circleId}
                                    >
                                      {circle.circleName.split(" [")[0]}
                                    </option>
                                  ))
                              ) : (
                                <option value="" disabled>
                                  No circles found
                                </option>
                              )
                            ) : null}
                          </select>
                          {!formInput.circleId && formSubmitted && (
                            <div className="required-message">
                              Circle is Required
                            </div>
                          )}
                        </div>
                        {/* )} */}
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1 small mb-1 small">{t("Ward")}</label>
                          <select
                            value={formInput.wardId}
                            name="wardId"
                            id="vehicle-filter-input"
                            className="form-select"
                            onChange={(e) =>
                              setFormInput((prevData) => ({
                                ...prevData,
                                wardId: e.target.value,
                              }))
                            }
                          // disabled={!formInput.circleId}
                          >
                            <option value="">Select</option>
                            {loadingWards && (
                              <option disabled>Loading Wards...</option>
                            )}
                            {Array.isArray(allWards) &&
                              allWards.filter((ward) => ward.isActive)
                                .map((ward) => (
                                  <option key={ward.wardId} value={ward.wardId}>
                                    {ward.wardName}
                                  </option>
                                ))}
                          </select>
                        </div>
                      </div>
                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1 small mb-1 small">Shift</label>
                          <select
                            value={formInput.shift}
                            id="vehicle-filter-input"
                            name="shift"
                            className={`form-select ${formInput.shift || !formSubmitted
                                ? ""
                                : "input-error"
                              }`}
                            onChange={(e) => handleShiftChange(e.target.value)}
                          >
                            <option value="">Select</option>
                            <option value="shiftA">Shift A</option>
                            <option value="shiftB">Shift B</option>
                            <option value="shiftC">Shift C</option>
                          </select>
                        </div>
                      </div>

                      <div className="col mb-3">
                        <div className="form-group-filter">
                          <label className="form-label small mb-1 small mb-1 small">Status</label>
                          <select
                            value={
                              isActive === true
                                ? "true"
                                : isActive === false
                                  ? "false"
                                  : ""
                            } // Convert boolean to string for value prop
                            id="vehicle-filter-input"
                            name="isActive"
                            className={`form-select ${isActive === "" && !formSubmitted
                                ? "input-error"
                                : ""
                              }`} // Add error class if needed
                            onChange={(e) => handleActiveChange(e.target.value)} // Handle change
                          >
                            <option value="true">Active</option>
                            <option value="false">InActive</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1 mb-3">
                    <button
                      type="button"
                      className={`btn  search ${isProd ? "search-ghmc" : "search-swm"
                        }`}
                      onClick={fetchAllCollectionPointDetails}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="top-header">
              <span>{t("Collection Point Details")}</span>
            </div>

            {/*------------------ -------Table------------------------------------------------- */}
            <div className="card">
              <div className="">
                {isCollectionLoading ? (
                  <Loader />
                ) : (
                  <TableComponent
                    DataFetchURL={collectionDetails}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 2
                      )
                    }
                    editData={handleEditCollectionDetails}
                    editDataDetails={editCollectionDetails}
                    viewData={(id) => handleViewCollectionPoints(id)}
                    onSort={handleSort}
                    skipGetCircle={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      {/* {!fetchDataLoaded && <Loader />} */}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => handleClose()}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            {" "}
            {editCollectionDetails ? t("editCollection") : t("addCollection")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <AddCollectionPoint
            editCollectionDetails={editCollectionDetails}
            edit={edit}
            setEdit={setEdit}
            handleViewCollectionPoints={handleViewCollectionPoints}
            fetchAllCollectionPointDetails={fetchAllCollectionPointDetails}
            setLgShow={setLgShow}
            editPermission={canWriteValue}
            allZones={allZones}
            collectionPointTypes={collectionPointTypes}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const FilterinputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
  backgroundColor: "white",
};

export default withTranslation()(GvpMaster);
